import { render, staticRenderFns } from "./sound2.vue?vue&type=template&id=c1899742&scoped=true&"
import script from "./sound2.vue?vue&type=script&lang=js&"
export * from "./sound2.vue?vue&type=script&lang=js&"
import style0 from "./sound2.vue?vue&type=style&index=0&id=c1899742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1899742",
  null
  
)

export default component.exports